export default __webpack_public_path__ + "files/ff9073c565c3d3e6e9d8001758a1217f.png";